module.exports = __webpack_public_path__ + "fonts/unicons.58f07f4c.eot";